 
export enum RfqStep {
   QUOTATION_DETAILS = 'quotation_details',
   VERIFY_EMAIL = 'verify_email',
   RECOGNIZED_EMAIL = 'recognized_email',
   CONTACT_DETAILS = 'contact_details',
   ADDRESS_DETAILS = 'address_details',
   DELIVERY_AREA = 'delivery_area',
   SUMMARY = 'summary',
   FINAL_MESSAGE = 'final_message'
}

export interface RequestForQuotationStep {
   submit: () => Promise<void>;
}
